define(function(require) {

    var lpEngagementHistoryController = require('web-agent-assets-js/lpEngagementHistoryController');

    /**
     * Important! in case that the product will want specific filtering for each visitor, a code change has to be made in the parent controller "lpEngagementHistoryController"
     * @param model
     * @returns {lpTag.lpEngagementHistoryController}
     */
    lpTag.lpEngagementsHistoryVisitorController = function(model) {
        var timeNow = new Date().getTime();
        var maxTimeRange = 15724800000; // 6 months

        var defaultSearch = {
            query: {
                offset: 0,
                limit: 100,
                sort: 'start:desc'
            },
            body: {
                interactive: true,
                ended: true,
                start: {
                    from: timeNow - maxTimeRange,
                    to: 'Now' // This value represents to the service that we want the most recent results
                }
            }
        };

        var controllerConfig = {
            applicationType: 'lpEngagementsHistoryVisitorController',
            model: model,
            modelPath: 'engagementsHistoryByVisitor',
            defaultSearchParameters: defaultSearch,
            modifyDataCallback: modifyEngagementObjects,
            supportOperatorAndSkillNames: false
        };

        var engagementsHistoryVisitorController = new lpTag.lpEngagementHistoryController(
            controllerConfig
        );

        //////////////////// public methods /////////////////////////

        engagementsHistoryVisitorController.getChatHistory = function(
            searchData
        ) {
            searchData = searchData || {};
            searchData.engagementHistoryPath =
                controllerConfig.modelPath + '.' + searchData.visitorId;
            engagementsHistoryVisitorController.updateQuery(searchData);
        };

        //////////////////// private methods /////////////////////////

        function modifyEngagementObjects(engagementsArray) {
            for (var i = 0; i < engagementsArray.length; i++) {
                engagementsHistoryVisitorController.modifyEngagementObject(engagementsArray[i]);
                engagementsArray[i].info = getEngagementInfo(engagementsArray[i]);
                engagementsArray[i].transcript.line = engagementsArray[i].transcript.lines;

                if (engagementsArray[i].info.agentDeleted){
                    var infoAgentId = Number(engagementsArray[i].info.agentId);

                    for (var j = 0; j < engagementsArray[i].transcript.line.length; j++) {
                        var lineAgentId = engagementsArray[i].transcript.line[j].agentId;

                        if (infoAgentId === lineAgentId){
                            engagementsArray[i].transcript.line[j].agentDeleted = true;
                        }
                    }
                }

                delete engagementsArray[i].transcript.lines;

                // This a temp solution.
                // We place all the survey questions on this fake custom variables property since this is how the UI knows to render it.
                // Later, when we will replace the info area in the widget with the new visitInfo implementation, we should handle this in a different way.
                engagementsArray[i].customVariables = {
                    customVariable: getSurveyQuestions(engagementsArray[i])
                };
                delete engagementsArray[i].surveys;
            }
        }

        function getEngagementInfo(engagementObject) {
            var engagementInfo = {
                agentId: engagementObject.info.agentId,
                duration: engagementObject.info.duration * 1000,
                startTime: engagementObject.info.startTimeL,
                endTime: engagementObject.info.endTimeL,
                visitorName: engagementObject.info.visitorName,
                visitorId: engagementObject.info.visitorId,
                engagementId: processEngagementForDisplay(
                    engagementObject.info.engagementId
                ),
                engagementSequence: engagementObject.info.engagementSequence,
                agentName:
                    engagementObject.info.agentNickName ||
                    engagementObject.info.agentFullName ||
                    engagementObject.info.agentLoginName,

                agentDeleted: engagementObject.info.agentDeleted
            };
            if (controllerConfig.supportOperatorAndSkillNames) {
                engagementInfo.agentName = engagementObject.info.agentName;
                engagementInfo.skill = engagementObject.info.skillName;
            }
            return engagementInfo;
        }

        function processEngagementForDisplay(rawEngagementId) {
            return rawEngagementId
                .replace(LE.loginInfo.accountId, '')
                .split('-')[0];
        }

        /**
         * This method takes all the received survey questions and place them in one array.
         * This is in use currently since the UI does not support dividing the questions according to the survey type.
         * @param engagementObject
         */
        function getSurveyQuestions(engagementObject) {
            var surveyQuestions = [];
            if (engagementObject.surveys) {
                if (engagementObject.surveys.preChat) {
                    surveyQuestions.push.apply(
                        surveyQuestions,
                        engagementObject.surveys.preChat
                    );
                }
                if (engagementObject.surveys.postChat) {
                    surveyQuestions.push.apply(
                        surveyQuestions,
                        engagementObject.surveys.postChat
                    );
                }
                if (engagementObject.surveys.operator) {
                    surveyQuestions.push.apply(
                        surveyQuestions,
                        engagementObject.surveys.operator
                    );
                }
            }
            return surveyQuestions;
        }
        ////////////////////////////////////////////////////////////////

        return engagementsHistoryVisitorController;
    };

    return lpTag.lpEngagementsHistoryVisitorController;
});


